import styled from "styled-components/macro";

import { BoardContextProvider } from "Boards/BoardContext";

import { useShouldShowSignupBoard } from "../../utils/useShouldShowSignupBoard";

import MoreOptionsContent from "./MoreOptionsContent";
import SignupBoard from "./SignupBoard";

export default function RespondentsData() {
  const showBoard = useShouldShowSignupBoard();

  return (
    // We need the BoardContextProvider at this level, as the Export option in MoreOptionsContent
    // also checks for the presence of a boardID in context to know what kind of export to use.
    <BoardContextProvider>
      <Wrapper data-cy="respondentsDataWrapper">
        {showBoard ? <SignupBoard /> : <MoreOptionsContent />}
      </Wrapper>
    </BoardContextProvider>
  );
}

const Wrapper = styled.div`
  padding: 18px;
  box-sizing: border-box;
  max-height: 100%;
  overflow: auto;
  padding-bottom: 140px;
  height: 100vh; // forces enough height to show the board taking up entire window

  @media (max-width: 840px) {
    height: auto; // at this point, board should collapse to only take up vertical room as needed
  }
`;
